<template>
  <div class="icon-arrow">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.59009 16.59L13.1701 12L8.59009 7.41L10.0001 6L16.0001 12L10.0001 18L8.59009 16.59Z"
        fill="white"
        :transform="transformValue"
      />
    </svg>
  </div>
</template>

<script setup>

const props = defineProps({
  direction: {
    type: String,
    default: 'right',
  },
})

const transformValue = computed(() => {
  const value = {
    top: 'translate(0 25) rotate(-90)',
    right: 'translate(0 0)',
    bottom: 'translate(24 2) rotate(90)',
    left: 'translate(24 24) rotate(180)',
  }
  return value[props.direction]
})
</script>

<style lang="scss" scoped>
.icon-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  svg {
    width: 100%;
    height: 100%;
    path {
      fill: currentColor;
    }
  }
}
</style>
